<template>
    <div class="setup-detail-content">
        <div class="setup-detail-item">
            <div class="item-label">直播名称：</div>
            <div class="item-content">{{ liveDetail.title ? liveDetail.title : '--' }}</div>
        </div>
        <div class="setup-detail-item">
            <div class="item-label">直播频道号：</div>
            <div class="item-content">{{ liveDetail.id ? liveDetail.id : '--' }}</div>
        </div>
        <div class="setup-detail-item">
            <div class="item-label">直播间密码：</div>
            <div class="item-content">{{ liveDetail.password ? liveDetail.password : '--' }}</div>
        </div>
        <div class="setup-detail-item">
            <div class="item-label">开播时间：</div>
            <div class="item-content">{{ liveDetail.begin_time ? liveDetail.begin_time : '--' }}</div>
        </div>
        <div class="setup-detail-item">
            <div class="item-label">结束时间：</div>
            <div class="item-content">{{ liveDetail.end_time ? liveDetail.end_time : '--' }}</div>
        </div>
        <div class="setup-detail-item">
            <div class="item-label">直播时长：</div>
            <div class="item-content">{{ liveDetail.duration | formatDate }}</div>
        </div>
        <div class="setup-detail-item">
            <div class="item-label">直播封面：</div>
            <div class="item-content">
                <div class="item-cover">
                    <img :src="liveDetail.cover">
                </div>
            </div>
        </div>
        <div class="setup-detail-item">
            <div class="item-label">直播介绍：</div>
            <div class="item-content">{{ liveDetail.intro ? liveDetail.intro : '--' }}</div>
        </div>
        <!-- <div class="setup-detail-item">
            <div class="item-label">服务器地址：</div>
            <div class="item-content">
                <span>https://yiwu.busionline.com/#/class/list/table/?id=133</span>
                <a :data-clipboard-text="'https://yiwu.busionline.com/#/class/list/table/?id=133'" class="clipboard" @click="copy">复制</a>
            </div>
        </div>
        <div class="setup-detail-item">
            <div class="item-label">串流密钥：</div>
            <div class="item-content">
                <span>https://yiwu.busionline.com/#/class/list/table/?id=133</span>
                <a type="text" :data-clipboard-text="'https://yiwu.busionline.com/#/class/list/table/?id=133'" class="clipboard" @click="copy">复制</a>
            </div>
        </div>
        <div class="setup-detail-item">
            <div class="item-label">网页观看链接：</div>
            <div class="item-content">
                <span>https://yiwu.busionline.com/#/class/list/table/?id=133</span>
                <a type="text" :data-clipboard-text="'https://yiwu.busionline.com/#/class/list/table/?id=133'" class="clipboard" @click="copy">复制</a>
            </div>
        </div> -->
    </div>
</template>
<script>
import Clipboard from 'clipboard'

export default {
    name: 'setupDetail',
    props: ['liveDetail'],
    data() {
        return {
        }
    },
    created() {
    },
    filters: {
        formatDate(value) {
            var result = ''
            var time = parseInt(value)
            var hr = parseInt(time / 60 / 60)
            var min = parseInt((time / 60) % 60)
            var sec = parseInt(time % 60)
            hr = hr > 9 ? hr : '0' + hr
            min = min > 9 ? min : '0' + min
            sec = sec > 9 ? sec : '0' + sec
            if (hr !== '00') {
                result = hr + ':' + min + ':' + sec
            } else {
                result = '00:' + min + ':' + sec
            }
            return result
        }
    },
    methods: {
        copy() {
            var clipboard = new Clipboard('.clipboard')
            clipboard.on('success', e => {
                this.$message({
                    type: 'success',
                    message: '复制成功'
                })
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                this.$message({
                    type: 'error',
                    message: '该浏览器不支持复制'
                })
                clipboard.destroy()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.setup-detail-content{
    padding: 12px 0 26px;
    .setup-detail-item{
        display: flex;
        margin-bottom: 12px;
        line-height: 24px;
        font-size: 14px;
        .item-label{
            color: #333;
        }
        .item-content{
            color: #666;
            flex: 1;
            .item-cover{
                width: 264px;
                height: 148px;
                img{
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }
            .clipboard{
                margin-left: 8px;
                cursor: pointer;
                color: $primaryColor;
                &:hover,&:focus{
                    color: $bthHoverColor;
                }
                &:active{
                    color: $bthActiveColor;
                }
            }
        }
        &:last-child{
            margin-bottom: 0;
        }
    }
}
</style>
